import React, { Component } from 'react';
import { Col, Row, Form, Button, Container, Spinner } from 'react-bootstrap';
import SelectDropDown from '../selectdropdown/SelectDropDown';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import * as Cookies from 'es-cookie';
import * as compose from 'lodash.flowright';
import jsPDF from 'jspdf';


// GraphQL query
const FETCH_EXAMNAMES = gql`
  query ($institute_id: Int!) {
    getOfflineExams(institute_id: $institute_id) {
      id
      exam_name
      exam_id
      sections_data {
        section_name
        subject_id
        subject_name
        no_of_questions
      }
    }
  }
`;


const UPLOAD_TEMPLATES = gql`
  mutation createTemplates($files: JSON, $exam_paper_id: ID) {
    createTemplates(files: $files, exam_paper_id: $exam_paper_id)
  }
`;
 
class NewOmrDload extends Component {
    constructor() {
        super();
        this.state = {
            selectedOption1: null,
            examDropDown: [],
            sectionData: {},
            activeSubject: "",
            examsData: [],
            selectedExam: '0',
            loader: false
        };
    }

    componentDidMount() {
        const { getExamNames } = this.props;
        if (getExamNames?.getOfflineExams) {
            const data = getExamNames.getOfflineExams.map((item) => ({
                value: item.id,
                label: item.exam_name,
            }));

            this.setState({
                examDropDown: data,
                examsData: getExamNames.getOfflineExams,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.getExamNames?.getOfflineExams &&
            prevProps.getExamNames?.getOfflineExams !== this.props.getExamNames?.getOfflineExams
        ) {
            const data = this.props.getExamNames.getOfflineExams.map((item) => ({
                value: item.id,
                label: item.exam_name,
            }));
            this.setState({ examDropDown: data, examsData: this.props.getExamNames.getOfflineExams, });
        }
    }

    selecthandleInputChange = (_name, value) => {
        const selected = this.state.examDropDown.find((item) => item.value === value);
        const data = this.state.examsData.find(item => item.id === value);
        const sectionData = data.sections_data || [];

        const subjects = {};

        sectionData.forEach(section => {
            const subjectName = section.subject_name;
            const sectionName = section.section_name;
            const count = section.no_of_questions;

            if (!subjects[subjectName]) {
                subjects[subjectName] = [];
            }

            subjects[subjectName].push({
                name: sectionName,
                count: count
            });
        });

        const structuredData = {
            subjects
        };

        this.setState({
            selectedOption1: selected,
            selectedExam: data.exam_id,
            sectionData: structuredData
        });
    };




    generatePDF = (e) => {
        e.preventDefault();
        const doc = new jsPDF('p', 'mm', 'a4');

        // === CONSTANTS ===
        const radius = 1.8;
        const gapY = 4.5;
        const gapX = 7;
        const startX = 15;
        const startY = 15;
        const pageWidth = 210;
        const pageHeight = 297;
        const rowGap = 5.5;
        const bubblesPerQ = 4;
        const sectionLabelHeight = 4;

        const markerSize = 6;
        const imageDataUrl = 'data:image/jpeg;base64,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';

        const bubbleData = [];

        // === ALIGNMENT MARKERS ===
        doc.addImage(imageDataUrl, 'JPEG', 5, 5, markerSize, markerSize);
        doc.addImage(imageDataUrl, 'JPEG', pageWidth - 5 - markerSize, 5, markerSize, markerSize);
        doc.addImage(imageDataUrl, 'JPEG', 5, pageHeight - 5 - markerSize, markerSize, markerSize);
        doc.addImage(imageDataUrl, 'JPEG', pageWidth - 5 - markerSize, pageHeight - 5 - markerSize, markerSize, markerSize);

        // === HEADER ===
        let collegeName = Cookies.get("name") || "Your College Name";
        let textSize = collegeName.length < 10 ? 20 : 0;
        const headerX = 165;
        const headerY = 12;

        doc.setFontSize(15);
        doc.setFont('helvetica', 'bold');
        doc.text(collegeName, headerX - textSize, headerY, { align: 'right' });
        doc.setFontSize(9);
        doc.text("OMR ANSWER SHEET", 160, headerY + 5.5, { align: 'right' });

        // === NAME & SIGNATURE FIELDS ===
        const nameY = headerY + 13;
        const labelX = 100;
        const lineStartX = labelX + 30;
        const lineEndX = 200;

        doc.setFontSize(10);
        doc.text("Name:", labelX, nameY);
        doc.line(lineStartX, nameY, lineEndX, nameY);

        const infoY = nameY + 7;
        doc.setFontSize(9);
        doc.text("Roll Number:", labelX, infoY);
        doc.line(lineStartX, infoY, lineEndX, infoY);

        const signatureY = infoY + 7;
        doc.text("Student Signature:", labelX, signatureY);
        doc.line(lineStartX, signatureY, lineEndX, signatureY);

        const lecturerY = signatureY + 7;
        doc.text("Lecturer Signature:", labelX, lecturerY);
        doc.line(lineStartX, lecturerY, lineEndX, lecturerY);

        // === ROLL NUMBER BUBBLES ===
        doc.setFontSize(12);
        doc.text("Roll Number:", startX, startY - 7);
        doc.setFont('helvetica', 'normal');

        for (let col = 0; col < 10; col++) {
            const x = startX + col * gapX;
            doc.setFontSize(6);
            doc.setLineWidth(0.4);

            for (let row = 0; row <= 9; row++) {
                const y = startY + row * gapY;

                const label = `${row}`;
                const textWidth = doc.getTextWidth(label);
                const textX = x - textWidth / 2;
                const textY = y + 0.8; // adjust as needed to center vertically

                if (col === 0) {
                    doc.text(`${row}`, startX - 5, y + 1.3); // Optional: row label outside the grid
                }

                doc.circle(x, y, radius);           // Draw bubble
                doc.text(label, textX, textY);      // Draw number inside bubble
            }
        }


        // === QUESTION BUBBLES (Subject Columns with Section Dividers) ===
        const baseY = startY + 6.5 * gapY + 18;
        const baseX = startX;
        let questionNumber = 1;

        let currentX = baseX;

        Object.entries(this.state.sectionData.subjects).forEach(([subject, sections]) => {
            const hasValidSections = sections.some(section => section.count > 0);
            if (!hasValidSections) return;

            const fontSize = 6.5;
            const verticalPadding = 1.5;
            const horizontalPadding = 2;
            const horizonatalBubbleGap = this.state.selectedExam == 2 && sections.length > 1 ? 5.5 : 6;
            const subjectToSubjectSpace = this.state.selectedExam == 2 && sections.length > 1 ? -3 : 20;
            const numberToBubbleGap = this.state.selectedExam == 2 && sections.length > 1 ? 6 : 10;
            const columnMax = 45;

            let cursorY = baseY;
            let subjectX = currentX;
            let labelX = subjectX + horizontalPadding + 10;
            let hasPrintedSubject = false;
            let maxBubblesThisSubject = 0;
            let currentColumnQuestionCount = 0;

            sections.forEach((section) => {
                if (section.count <= 0) return;

                const isSectionB = section.name === 'Section B' && this.state.selectedExam == 2;

                // Print subject header once
                if (!hasPrintedSubject) {
                    doc.setFontSize(8);
                    doc.setFont('helvetica', 'bold');
                    doc.text(subject, labelX, cursorY);
                    cursorY += 3;
                    hasPrintedSubject = true;
                }

                doc.setFontSize(fontSize);
                doc.setFont('helvetica', 'bold');
                cursorY += verticalPadding;
                doc.text(section.name, labelX, cursorY);
                cursorY += verticalPadding + sectionLabelHeight;

                doc.setFontSize(6);
                doc.setFont('helvetica', 'normal');

                for (let i = 0; i < section.count; i++) {
                    // If more than 45 questions rendered, start new column
                    if (currentColumnQuestionCount >= columnMax) {
                        subjectX += maxBubblesThisSubject * 6.5 + subjectToSubjectSpace;
                        labelX = subjectX + horizontalPadding + 10;
                        cursorY = baseY;

                        currentColumnQuestionCount = 0;

                        // Adjust cursorY to maintain vertical alignment
                        if (hasPrintedSubject) cursorY += 3;
                        cursorY += verticalPadding;
                        doc.setFontSize(fontSize);
                        doc.setFont('helvetica', 'bold');
                        doc.text(section.name, labelX, cursorY);
                        cursorY += verticalPadding + sectionLabelHeight;

                        doc.setFontSize(6);
                        doc.setFont('helvetica', 'normal');
                    }

                    // Draw question number
                    doc.text(`${questionNumber}`, subjectX, cursorY + 1);

                    const bubblesForThisQuestion = isSectionB ? 10 : bubblesPerQ;
                    maxBubblesThisSubject = Math.max(maxBubblesThisSubject, bubblesForThisQuestion);

                    for (let j = 0; j < bubblesForThisQuestion; j++) {
                        const bx = subjectX + numberToBubbleGap + j * horizonatalBubbleGap;
                        const by = cursorY;

                        // Draw the bubble
                        doc.circle(bx, by, radius);

                        // Draw label inside the bubble
                        doc.setFontSize(5.2);
                        doc.setFont('helvetica', 'normal');
                        const label = isSectionB ? `${j}` : String.fromCharCode(65 + j);
                        const textWidth = doc.getTextWidth(label);
                        doc.text(label, bx - textWidth / 2, by + 0.8);

                        // Save bubble data
                        bubbleData.push({
                            subject,
                            section: section.name,
                            question: questionNumber,
                            option: label,
                            x: parseFloat(bx.toFixed(2)),
                            y: parseFloat(by.toFixed(2)),
                            radius
                        });
                    }

                    cursorY += rowGap - 0.8;
                    questionNumber++;
                    currentColumnQuestionCount++;
                }
            });
            currentX = subjectX + maxBubblesThisSubject * 6.5 + subjectToSubjectSpace;
        });


        let omr_template = {
            "pageDimensions": [
                2480,
                3508
            ],
            "bubbleDimensions": [
                10,
                20
            ],
            "preProcessors": [
                {
                    "name": "CropOnMarkers",
                    "options": {
                        "relativePath": "marker.jpg",
                        "sheetToMarkerWidthRatio": 17
                    }
                }
            ],
            "customLabels": {
                "Roll_no": [
                    "r1",
                    "r2",
                    "r3",
                    "r4",
                    "r5",
                    "r6",
                    "r7",
                    "r8",
                    "r9",
                    "r10"
                ]
            },

            "fieldBlocks": {
                "Roll_no": {
                    "fieldType": "QTYPE_INT",
                    "origin": [
                        86,
                        77
                    ],
                    "fieldLabels": [
                        "r1",
                        "r2",
                        "r3",
                        "r4",
                        "r5",
                        "r6",
                        "r7",
                        "r8",
                        "r9",
                        "r10"
                    ],
                    "bubblesGap": 56,
                    "labelsGap": 90
                },
            }
        };

        let layoutData = this.state.sectionData.subjects;

        // Default values
        let defaultStartOMRX = 210;
        let defaultXGap = 590;
        let defaultBubblesGap = 77;

        // Alternate values for Exam 2 with more than 2 sections
        let altStartOMRX = 165;
        let altXGap = 790;
        let altBubblesGap = 70;

        let startOMY = 790;
        let yGap = 59;
        let questionsPerColumn = 45;

        let questionIndex = 1;
        let subjectIndex = 0;

        for (let subject in layoutData) {
            let sections = layoutData[subject];
            let useAltLayout = (this.state.selectedExam == 2 && sections.length > 1);
            let subjectStartX = (useAltLayout ? altStartOMRX : defaultStartOMRX) + subjectIndex * (useAltLayout ? altXGap : defaultXGap);
            let bubblesGap = useAltLayout ? altBubblesGap : defaultBubblesGap;

            let localIndex = 0;

            sections.forEach(section => {
                for (let i = 1; i <= section.count; i++) {
                    let columnWithinSubject = Math.floor(localIndex / questionsPerColumn);
                    let x = subjectStartX + columnWithinSubject * (useAltLayout ? altXGap : defaultXGap);
                    let y = startOMY + (localIndex % questionsPerColumn) * yGap;

                    if (section.name === "Section B") {
                        y += 86;
                    }

                    
                    
                    let blockName = `MCQ_Block_${questionIndex}`;
                    let label = `q${questionIndex}..${questionIndex}`;
                    console.log("yyyyyyyyyyy",questionIndex,y,useAltLayout,section.name);
                    
                    let fieldType = (useAltLayout && section.name === "Section B")
                        ? "QTYPE_INT_N_1"
                        : "QTYPE_MCQ4";

                    omr_template.fieldBlocks[blockName] = {
                        origin: [x, y],
                        bubblesGap: bubblesGap,
                        labelsGap: 90,
                        fieldType: fieldType,
                        fieldLabels: [label]
                    };
                    questionIndex++;
                    localIndex++;
                }
            });
            subjectIndex++;
        }



        const uploadOMRFile = async () => {
            // Validate required state
            const selectedExamPaperId = this.state.selectedOption1?.value;
            if (!selectedExamPaperId) {
                this.setState({ submitError: "Please select an exam paper to upload the OMR template." });
                return;
            }

            let omrJson;
            try {
                omrJson = JSON.stringify(omr_template);
            } catch (jsonError) {
                console.error("Error serializing OMR template:", jsonError);
                this.setState({ submitError: "Failed to serialize the OMR template." });
                return;
            }

            // Reset state before starting the upload
            this.setState({ loader: true, submitError: '', successMessage: '' });

            try {
                // Perform the GraphQL mutation to upload template
                await this.props.uploadTemplates({
                    variables: {
                        files: omrJson,
                        exam_paper_id: selectedExamPaperId,
                    },
                });

                // Generate and save the PDF if `doc` is defined
                if (typeof doc !== 'undefined' && typeof doc.save === 'function') {
                    doc.save("omr-sheet.pdf");
                } else {
                    console.warn("PDF document (doc) is not available or not a valid jsPDF instance.");
                }

                // Update UI on success
                this.setState({ successMessage: 'Upload and PDF download successful!' });

            } catch (error) {
                console.error("Upload error:", error);
                const errMsg =
                    error?.graphQLErrors?.map(x => x.message)?.join(", ") ||
                    error?.message ||
                    "Upload failed.";
                this.setState({ submitError: errMsg });
            } finally {
                this.setState({ loader: false });
            }
        };
        uploadOMRFile();
    };




    render() {

        const { getExamNames } = this.props;
        const loading = getExamNames?.loading;
        const error = getExamNames?.error;

        if (error) {
            alert('Server Error. ' + error.message);
            return null;
        }

        return (
            <Container fluid>
                {loading ? (
                    <Row className="my-2">
                        <Col>
                            <div className="spinner-border text-primary text-center loading-img-center"></div>
                        </Col>
                    </Row>
                ) : (
                    <Form onSubmit={this.handleSubmit} className="mb-3">
                        <Row className="align-items-end">
                            <Col lg={3} md={6} sm={12} className="mb-3">
                                <Form.Label className="text-uppercase font-weight-bold text-dark mt-2">
                                    Exam Name
                                </Form.Label>
                                <SelectDropDown
                                    stateData={this.state.selectedOption1}
                                    handleChange={this.selecthandleInputChange}
                                    name="exam_type"
                                    options={this.state.examDropDown}
                                    placeholderName="Select exam"
                                />
                            </Col>

                            <Col lg="auto" md="auto" sm="12" className="mb-3">
                                {Object.keys(this.state.sectionData).length > 0 && (
                                    <Button
                                        type="submit"
                                        variant="secondary"
                                        className="mt-4"
                                        onClick={(e) => { this.generatePDF(e) }}
                                        style={{
                                            background: '#213046',
                                            border: 'none',
                                        }}
                                    >
                                        {this.state.loader ? (
                                            <>
                                                <Spinner animation="border" size="sm" role="status" className="me-2" />
                                                Generation OMR ...
                                            </>
                                        ) : (
                                            "Generate OMR"
                                        )}
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </Form>
                )}
            </Container>
        );
    }
}


// Wrap component with GraphQL and withRouter
export default withRouter(
    compose(
        graphql(FETCH_EXAMNAMES, {
            options: () => ({
                variables: {
                    institute_id: parseInt(Cookies.get('institutionid')), 
                },
            }),
            name: 'getExamNames',
        }),
        graphql(UPLOAD_TEMPLATES, { name: "uploadTemplates" })
    )(NewOmrDload)
);
